import judahTheme from 'typography-theme-judah'

import { TypographyOptions } from './types.js'

export const typography: TypographyOptions = {
  /**
   * @tag Vite migration
   * 'typography-theme-judah' module provides a default export and breaks Rollup ESM-CJS interop
   * https://github.com/vitejs/vite/issues/2139#issuecomment-1024852072
   */
  ...(judahTheme.default ? judahTheme.default : judahTheme),
  baseFontSize: '16px',
}
